import React from "react";
import { Reveal } from "../shared/Reveal";
import CountUp from "../CountUp";

const HERO_BG =
  "linear-gradient(180deg,rgba(11,21,51,.52),rgba(11,21,51,.5) 45%,#0B1533),url('/brand/city_earth.jpg')";

export default function Hero({ go }) {
  return (
    <header className="hero" id="top" style={{ backgroundImage: HERO_BG }}>
      <div className="wrap">
        <Reveal className="kick" tag="div">MULTI-AWARD-WINNING · OPERATIONAL INTELLIGENCE</Reveal>
        <Reveal tag="h1">Making the <span className="g">Invisible Visible.</span></Reveal>
        <Reveal className="sub" tag="p">Every building has a signature — energy, water, carbon, occupancy and operations. We reveal it, prove the savings, and turn it into intelligence you can act on.</Reveal>
        <Reveal className="stmt" tag="p">Our Operational Intelligence Platform creates the digital foundation that prepares every building for the AI era.</Reveal>

        <Reveal className="partner" tag="p">Our clients gain access to technology developed over more than <span className="g">20 years</span> of research and development, operating in <span className="g">over 70 countries</span> and trusted by some of the world's leading brands.</Reveal>
        <Reveal className="cta" tag="div">
          <a href="/gap-analysis" className="btn" data-testid="hero-cta">Book Your Complimentary Gap Analysis</a>
          <a onClick={() => go("what")} className="btn ghost" data-testid="hero-secondary">See How It Works</a>
        </Reveal>
        <Reveal className="stats" tag="div">
          <div className="s"><div className="n"><CountUp to={70} suffix="+" /></div><div className="l">COUNTRIES WORLDWIDE</div></div>
          <div className="s"><div className="n"><CountUp to={16100} separator suffix="+" /></div><div className="l">ACTIVE ENERGY &amp; IoT HUBS</div></div>
          <div className="s"><div className="n"><CountUp to={5.3} decimals={1} suffix={"\u00A0Bn+"} /></div><div className="l">DATA POINTS EVERY DAY</div></div>
        </Reveal>
      </div>
    </header>
  );
}
